module.exports = __webpack_public_path__ + "static/media/autumn.39903016.png";